export type AlertDetailsLocationState = {
  from?: string;
  returnState?: unknown;
};

export type AlertTripNavigationTarget = {
  tripId: string;
  isMergedTrip: boolean;
};

export const buildCurrentPath = (pathname: string, search: string): string => (
  `${pathname}${search}`
);

export const buildAlertDetailsLocationState = (
  pathname: string,
  search: string,
  currentState?: unknown,
): AlertDetailsLocationState => ({
  from: buildCurrentPath(pathname, search),
  returnState: currentState ?? undefined,
});

export const getAlertDetailsReturnPath = (
  state: unknown,
): string | undefined => {
  const from = (state as AlertDetailsLocationState | null)?.from;
  return typeof from === 'string' && from.length > 0 ? from : undefined;
};

export const getAlertDetailsReturnState = (
  state: unknown,
): unknown => (state as AlertDetailsLocationState | null)?.returnState;

export const getAlertTripNavigationTarget = (
  alert: { tripId?: string | null; mergedTripId?: string | null },
  clientTripMergeEnabled: boolean,
): AlertTripNavigationTarget | null => {
  if (clientTripMergeEnabled && alert.mergedTripId) {
    return {
      tripId: alert.mergedTripId,
      isMergedTrip: true,
    };
  }

  if (alert.tripId) {
    return {
      tripId: alert.tripId,
      isMergedTrip: false,
    };
  }

  return null;
};
